import { useEffect, useState, useCallback, PropsWithChildren } from "react";
import ColumnResizeHandleContext from "./ColumnResizeHandleContext";

export default function ColumnResizeHandleProvider({
  children,
}: PropsWithChildren) {
  const [resizedColumnId, setResizedColumnId] = useState<string | null>(null);

  useEffect(() => {
    const onMouseUp = () => {
      document.body.style.cursor = "default";
      setResizedColumnId(null);
    };
    const onTouchEnd = () => {
      document.body.style.cursor = "default";
    };
    window.addEventListener("mouseup", onMouseUp);
    window.addEventListener("touchend", onTouchEnd);
    return () => {
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("touchend", onTouchEnd);
    };
  }, []);

  const startResize = useCallback((resizedColumnId: string) => {
    setResizedColumnId(resizedColumnId);
    document.body.style.cursor = "col-resize";
  }, []);

  return (
    <ColumnResizeHandleContext.Provider
      value={{ resizedColumnId, startResize }}
    >
      {children}
    </ColumnResizeHandleContext.Provider>
  );
}
